<template>
    <div>
        <!-- <div class="single-widgets widget_search">
            <h4 class="title">{{ $t('Search') }}</h4>
            <form class="sidebar-search-form">
                <input type="search" name="search" :placeholder="$t('Search')">
                <button type="submit"><i class="fa-solid fa-magnifying-glass"></i></button>
            </form>
        </div> -->
        <div class="single-widgets widget_thumb_post">
            <h4 class="title">{{$t('Exhibitions start soon')}}</h4>
            <ul>
                <li v-for="(item, index) in recentPost" :key="index">
                    <span class="left">
                        <img :src="item.logo" alt="logo" class="">
                    </span>
                    <span class="right">
                        <router-link class="feed-title" v-if="localizedExhibitPath(item)"
                                :to="localizedExhibitPath(item)">{{ item.name }}</router-link>
                        <span class="post-date"><i class="ti ti-calendar"></i> {{ item.start_date }}</span>
                    </span>
                </li>
            </ul>
        </div>
        <div class="single-widgets widget_category">
            <h4 class="title">{{$t('Categories')}}</h4>
            <ul>
                <li v-for="(category, index) in categories" :key="index">{{category.name}}</li>
            </ul>
        </div>        
    </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import axios from "axios";
import { ref, onMounted, watch, defineProps } from "vue";

const { locale } = useI18n();
const localizedExhibitPath = (item) => {
  const currentSlug = item.slug?.[locale.value]

  if (!currentSlug) return null  

  return `/${locale.value}/exhibit/${currentSlug}`
}
const recentPost = ref([]);
defineProps({
  categories: Object,
});
const fetchRecentPosts = async () => {
    try {
        const response = await axios.get(`/exhibits/newest?limit=5&lang=${locale.value}`);
        recentPost.value = response.data.data;
    } catch (error) {
        console.error("Error fetching recent exhibits:", error);
    }
};
onMounted(() => {
  fetchRecentPosts();
});

watch(locale, () => {
  fetchRecentPosts();
});
</script>
